<div class="row landing-container">

  <!-- Section1 -->
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
    <div class="row section1">

      <div class="col-lg-5 col-md-5 col-sm-12 col-xs-12 welcome-text-box section-padding-lg ">
        <div class="title">
          <div class="intro">TE DAMOS LA BIENVENIDA</div>
          ya eres parte de una nueva forma de hacer crecer tu negocio_
        </div>

        <div class="subtitle">Desde hoy, cuentas con liquidez,control y apoyo en equipo.</div>
        <button mat-flat-button class="btn-primary" (click)="explorarPlataforma()">explora tu plataforma</button>

      </div>

      <div class="col-lg-7 col-md-7 col-sm-12 col-xs-12 welcome-logo-box">
        <!-- <img src="../../assets/simpli/simplilogo2.svg" class="welcome-logo-box--img"> -->
        <img src="../../assets/bienvenida-img/1_WEB.png" class="welcome-logo-box--background">
      </div>
    </div>
  </div>

  <!-- Section2 -->
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
    <div class="row section2-row">
      <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 section-padding-left">
        <div class="title color-secondary padding-top text-md-start">¿qué puedes hacer desde hoy?_</div>
        <div class="subtitle color-tertiary text-md-start">Todas estas funcionalidades están disponibles desde el primer día</div>
      </div>

      <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12 feature-carousel section-padding-right">
        <button mat-icon-button class="icon-btn" (click)="prev()">
          <mat-icon>arrow_back_ios</mat-icon>
        </button>

        <div class="feature-boxes">
          <!-- Card previa -->
          <div class="promo-card promo-card--side">
            <div class="promo-card__media">
              <img [src]="boxes[prevIndex].img" alt="">
            </div>
            <div class="promo-card__body">
              <div class="promo-card__title">{{ boxes[prevIndex].title }}</div>
              <div class="promo-card__subtitle">{{ boxes[prevIndex].description }}</div>
              <button mat-flat-button class="btn-primary" (click)="realizarAccion(boxes[prevIndex].title )">{{ boxes[prevIndex].buttontext }}</button>
            </div>
          </div>

          <!-- Card actual -->
          <div class="promo-card promo-card--active">
            <div class="promo-card__media">
              <img [src]="boxes[currentIndexCarrusel].img" alt="">
            </div>
            <div class="promo-card__body">
              <div class="promo-card__titleactive">{{ boxes[currentIndexCarrusel].title }}</div>
              <div class="promo-card__subtitleactive">{{ boxes[currentIndexCarrusel].description }}</div>
              <div class="btn-white" (click)="realizarAccion(boxes[currentIndexCarrusel].title )">{{ boxes[currentIndexCarrusel].buttontext }}</div>
            </div>
          </div>

          <!-- Card siguiente -->
          <div class="promo-card promo-card--side">
            <div class="promo-card__media">
              <img [src]="boxes[nextIndex].img" alt="">
            </div>
            <div class="promo-card__body">
              <div class="promo-card__title">{{ boxes[nextIndex].title }}</div>
              <div class="promo-card__subtitle">{{ boxes[nextIndex].description }}</div>
              <button mat-flat-button class="btn-primary"  (click)="realizarAccion(boxes[nextIndex].title )">{{ boxes[nextIndex].buttontext }}</button>
            </div>
          </div>
        </div>

        <button mat-icon-button class="icon-btn" (click)="next()">
          <mat-icon>arrow_forward_ios</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <!-- Section3  -->
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
    <div class="row banner-text section-padding-lg background-img">
      <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
        <div class="title">lo que nos hace únicos_</div>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
        <div class="subtitle">Más que un factoring, <strong>somos tu socio estratégico para el crecimiento de tu
            negocio.</strong></div>
      </div>
    </div>
  </div>

  <!-- Section4  -->
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 section-box-carrusel">

        <button mat-icon-button class="icon-btn" (click)="prevImg()">
          <mat-icon>arrow_back_ios</mat-icon>
        </button>

        <div class="section-box">
          @for (item of visibleImgs; track $index) {
          <div class="section-box--card">
            <img [src]="item.img">
          </div>
          }
        </div>

        <button mat-icon-button class="icon-btn" (click)="nextImg()">
          <mat-icon>arrow_forward_ios</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <!-- Section5  -->
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 section-box-video">

        <!-- <button mat-icon-button class="icon-btn" (click)="prevVideo()">
          <mat-icon>arrow_back_ios</mat-icon>
        </button> -->

        @for (item of carruselVideo; track $index) {
        @if ($index === currentIndexVideo) {
        <div class="card-video">
          <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 card-video--text">
            <div class="title">{{ item.title }}</div>
            <div class="subtitle" [innerHTML]="item.subtitle"></div>
            <div class="section-2">
              <!-- <img [src]="item.img"> -->
              <div class="subtitle" [innerHTML]="item.description"></div>
            </div>
            <button mat-flat-button class="btn-secondary btn-blue">{{ item.button }}</button>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 card-video--video">
            <div class="video-container">
              <img src="../../assets/bienvenida-img/fondo sección 9.png" class="video-thumbnail" (click)="playVideo()"
                [class.hidden]="isVideoPlaying" alt="Video thumbnail">

              @if (isLoadingVideo && !isVideoLoaded) {
              <img src="../../assets/bienvenida-img/fondo sección 9.png" class="video-thumbnail loading-bg"
                alt="Loading background">
              <div class="loading-spinner">
                <mat-spinner diameter="50"></mat-spinner>
              </div>
              }

              @if (isVideoPlaying) {
              <video #videoPlayer [src]="item.video" width="100%" height="100%" autoplay muted controls
                (canplay)="onVideoLoaded()" [class.hidden]="!isVideoLoaded"></video>
              }

              <div class="play-button" (click)="playVideo()" [class.hidden]="isVideoPlaying">
                <img src="../../assets/bienvenida-img/icono PLAY VIDEOS.png">
              </div>
            </div>
          </div>
        </div>
        }
        }

        <!-- <button mat-icon-button class="icon-btn" (click)="nextVideo()">
          <mat-icon>arrow_forward_ios</mat-icon>
        </button> -->

      </div>
    </div>
  </div>

  <!-- Section6  -->
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
    <div class="row section-6">
      <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 section-6--bg">
        <img src="../../assets/bienvenida-img/foto seccion 6.png">
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 section-6--content section-padding-lg">
        <div class="title">en simpli siempre hay alguien al otro lado_</div>
        <div class="subtitle"><strong>Te acompañamos en cada paso, con datos, experiencia y cercanía humana
            real.</strong></div>
        <div class="subtitle2">Nuestro equipo está aquí para que nunca te sientas solo en el proceso de hacer crecer tu
          empresa.
          En cada consulta, en cada duda y en cada celebración, estamos contigo.</div>
        <div class="section-6--btn">
          <button mat-flat-button class="btn-primary" (click)="contactarSoporte()">¿Necesitas ayuda?</button>
        </div>

      </div>
    </div>
  </div>

  <!-- Section8  -->
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 section8">
        <div class="title">¿tienes preguntas?_</div>
        <div class="subtitle">Nuestro equipo está aquí para ayudarte</div>
        <button mat-flat-button class="btn-primary2" (click)="contactarSoporte()">Contactar a soporte</button>
      </div>
    </div>
  </div>

</div>